import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './page-footer.scss';
import { setupButtons, buttonClick } from './page-footer-actions';
import PageButton from '../../components/page-button/page-button';
import Text from './page-footer-text';


@styleable(css)
class PageFooter extends Component {
    /** @todo define the types of each prop */
    static propTypes = {
        /** @todo use the props declared below and remove the eslint directive on the next line */
        /* eslint react/no-unused-prop-types: 0 */
        pageFooterReducer: PropTypes.object,
        setupButtons: PropTypes.func,
        buttonClick: PropTypes.func
    };

    componentWillUpdate() {}

    componentDidMount() {
    }

    render() {
        const { leftSideButtons, rightSideButtons } = this.props.pageFooterReducer;

        const leftButtons = leftSideButtons.map(item =>
            <PageButton key={item.label} onClick={() => this.props.buttonClick(item)}>{Text[item.label]}</PageButton>
        );
        const rightButtons = rightSideButtons.map((item) => {
            const btnDisable = item.data ? item.data.disabled : true;
            return (
                <PageButton
                    key={item.label}
                    disabled={btnDisable}
                    onClick={() => {
                        if (typeof item.action === 'function') {
                            item.action();
                        }
                        this.props.buttonClick(item);
                    }}>
                    {Text[item.label]}
                </PageButton>);
        });
        return (
            leftSideButtons.length === 0 && rightSideButtons.length === 0 ?
                null :
                <div className={`page-footer ${css['page-footer']}`} >
                    <div className={css['left-side']}>
                        {leftButtons}
                    </div>
                    <div className={css['left-side']}>
                        {rightButtons}
                    </div>
                </div>
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from PageFooterCombinedReducers.
 */
function mapStateToProps(state) {
    return {
        pageFooterReducer: state.pageFooterReducer
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    /**
     * @todo ensure that 'actionCreator' below matches the name
     * of the corresponding action creator function in page-footer-actions.js,
     * and add an action creator entry for each action the component uses.
     */
    return bindActionCreators({
        setupButtons,
        buttonClick
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PageFooter);



// WEBPACK FOOTER //
// ./components/page-footer/page-footer.js